var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiAccordion from '@mui/material/Accordion';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import KeyboardArrowDownOutlined from '@mui/icons-material/KeyboardArrowDownOutlined';
import { colorPalette } from '../../colorPalette';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import * as styles from './Accordion.style';
export const Accordion = (props) => {
    const { title, titleTypographyVariant, subTitle = '', children, icon, isLite = false, titleStyle, summaryStyle, detailsStyle, expanded, onChange } = props, rest = __rest(props, ["title", "titleTypographyVariant", "subTitle", "children", "icon", "isLite", "titleStyle", "summaryStyle", "detailsStyle", "expanded", "onChange"]);
    return (React.createElement(MuiAccordion, Object.assign({ expanded: expanded, onChange: onChange, disableGutters: true, elevation: 0, sx: isLite ? styles.customAccordionLiteStyle : styles.customAccordionClassicStyle }, rest),
        React.createElement(MuiAccordionSummary, { sx: Object.assign(Object.assign({}, styles.customSummaryStyle(props)), (summaryStyle || {})), expandIcon: React.createElement(KeyboardArrowDownOutlined, { htmlColor: colorPalette.gray700, style: { fontSize: '18px' } }) },
            React.createElement(Box, { sx: { width: '100%', display: 'flex', flexDirection: 'row' } },
                icon ? React.createElement(Box, { sx: styles.iconStyle(props) }, icon) : null,
                React.createElement(Box, { sx: styles.generalSummary },
                    React.createElement(Typography, { variant: titleTypographyVariant, sx: Object.assign(Object.assign({}, styles.titleStyle), (titleStyle || {})) }, title),
                    subTitle ? React.createElement(Typography, { sx: styles.subTitleStyle }, subTitle) : null))),
        React.createElement(AccordionDetails, { sx: [styles.customAccordionDetailsStyle(props), ...(Array.isArray(detailsStyle) ? detailsStyle : [detailsStyle])] },
            React.createElement(Box, { sx: styles.detailsContent }, children))));
};
